import Enum from "@/util/enum";
import EnumValue from ".";

export default class Gender extends Enum {
  static MALE: EnumValue = { name: "Male", code: 0 };
  static FEMALE: EnumValue = { name: "Female", code: 1 };
  static UNKNOWN: EnumValue = { name: "Unknown", code: 2 };
}
